import { NCS } from '../../common/constants.tsx';
import type { Category, CategoryGuid } from '../../common/types.tsx';
import type { CategoriesState } from './types.tsx';

export const getDraftEditUrl = (
	projectKey: string,
	selectedSpaceKey: string,
	articleId: string,
	draftShareId: string,
	topicId?: string,
): string => {
	let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
	if (topicId) draftEditUrl += `&topicId=${topicId}`;
	return draftEditUrl;
};

export const isDraftCreatedWithNCS = (collabService: string): boolean => collabService === NCS;

export const findCategory = (
	categoriesData: CategoriesState,
	categoryId: CategoryGuid,
): Category | undefined => {
	if (categoriesData.categories) {
		return categoriesData.categories.find((category) => category.id === categoryId);
	}
	return undefined;
};
